import { render } from "./OpenSourceView.vue?vue&type=template&id=4c420e31&scoped=true"
import script from "./OpenSourceView.vue?vue&type=script&lang=js"
export * from "./OpenSourceView.vue?vue&type=script&lang=js"

import "./OpenSourceView.vue?vue&type=style&index=0&id=4c420e31&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c420e31"]])

export default __exports__